var map = {
	"./create-new-campaign.png": "fc31",
	"./done-checking.png": "790e",
	"./done-checking.svg": "9a94",
	"./girl-clock.png": "eba5",
	"./image-template.png": "5d34",
	"./image-template.svg": "b41fd",
	"./messages.png": "dec7",
	"./not_available.jpg": "9d83",
	"./reporting.png": "c421",
	"./rocket.svg": "1929",
	"./stars.svg": "3e35",
	"./text-template.png": "12ee",
	"./text-template.svg": "9ef6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";